import styled, { keyframes } from "styled-components";

export const ExperienceWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 40px 20px;
`

export const ExperienceDivider = styled.div`
    justify-content: center;
    padding: 10px;
`

export const ExperienceSectionHeader = styled.h1`
    margin-top: 10px;
    padding: 10px;
    border-bottom: 3px solid #3b82f6;
`

export const CardContainer = styled.div`
    padding: 10px;
    display: flex;
    justify-content: center;
    gap: 20px;
    @media(max-width: 1000px) {
        flex-direction: column;
        align-items: center;
    }
`

export const fadeIn = keyframes`
    from {
        opcity: 0;
        transform: translateY(40px);
    } to {
        opacity: 1;
        transform: trasnlateY(0);
    }
`

export const ExperienceCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-radius: 18px;
    width: 350px;
    min-height: 280px;
    overflow: hidden;
    padding: 20px 15px;
    background: linear-gradient(135deg, #f9f9f9 60%, #dbeafe 100%);
    box-shadow: 0 8px 32px rgba(59, 130, 246, 0.12), 0 2px 8px rgba(0,0,0,0.08);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    margin-bottom: 20px;
    position: relative;
    transform: translateY(0);
    ${'' /* animation: ${fadeIn} 0.3s ease-in forwards ; */}

    &:hover {
        box-shadow: 0 12px 48px rgba(59, 130, 246, 0.20), 0 4px 16px rgba(0,0,0,0.15);
        transform: translateY(-8px);
        background: linear-gradient(135deg, #fff 60%, #bfdbfe 100%);
        cursor: pointer;
    }

    &.expanded {
        transform: scale(1.02) translateY(-2px);
        box-shadow: 0 16px 56px rgba(59, 130, 246, 0.18), 0 6px 20px rgba(0,0,0,0.12);
        background: linear-gradient(135deg, #ffffff 60%, #dbeafe 100%);
    }

    &.expanded:hover {
        transform: scale(1.02) translateY(-6px);
    }

    @media(max-width: 600px) {
        width: 95%;
        padding: 10px 5px;
        min-height: 260px;
    }
`

export const CompanyLogo = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    align-self: center;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    margin-bottom: 15px;
`

export const CardHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
`

export const JobTitle = styled.p`
    font-size: 1.2rem;
    margin: 0 0 8px 0;
    color: #3b82f6;
    text-align: center;
    background: 'red';
`

export const CompanyDateContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 15px;
    margin-bottom: 10px;

    @media(max-width: 500px) {
        flex-direction: column;

    }
`

export const CompanyName = styled.p`
    font-weight: 700;
    margin: 0;
    font-size: 1.1rem;
    color: #1f2937;
`

export const CompanyDate = styled.p`
    font-weight: 500;
    margin: 0;
    color: #6b7280;
    font-size: 0.95rem;
`

export const ExpandButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
`

export const DividerLine = styled.div`
    height: 1px;
    background: linear-gradient(90deg, transparent, #3b82f6, transparent);
    flex: 1;
    margin: 0 15px;
`

export const StyledIconButton = styled.button`
    background: ${props => props.$showMore
        ? 'linear-gradient(135deg, #3b82f6, #2563eb)'
        : 'linear-gradient(135deg, #f8fafc, #e2e8f0)'};
    color: ${props => props.$showMore ? 'white' : '#3b82f6'};
    width: 44px;
    height: 44px;
    box-shadow: ${props => props.$showMore
        ? '0 6px 24px rgba(59, 130, 246, 0.35)'
        : '0 3px 12px rgba(0, 0, 0, 0.12)'};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${props => props.$showMore ? 'rotate(180deg) scale(1.05)' : 'rotate(0deg) scale(1)'};
    border: ${props => props.$showMore ? 'none' : '1px solid #e2e8f0'};
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const CollapseContent = styled.div`
    padding: 20px;
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.05), rgba(147, 197, 253, 0.08));
    border-radius: 12px;
    margin: 10px 0;
    border: 1px solid rgba(59, 130, 246, 0.1);
    backdrop-filter: blur(10px);
`

export const BulletPointsList = styled.ul`
    margin: 0;
    padding: 0 0 0 20px;
    color: #374151;
    line-height: 1.6;
`

export const BulletPointItem = styled.li`
    margin-bottom: 12px;
    font-size: 0.95rem;
    font-weight: 500;
`